import { useCreditCardSetupContext } from '@apps/registry/admin/components/CreditCardSetup/CreditCardSetUp.context';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { hasActiveStripeAccount } from '@shared/utils/payoutAccount';
import { useShippingAddressAndCurrencyDialogsContext } from '../components/ShippingAddressAndCurrencyDialogsProvider';

export const useShouldShowConnectBankAccountButton = () => {
  const [isI18nEnabled] = useIsFeatureEnabled('registryCashFundCurrency18nEnabled');
  const { payoutAccountInfo, canManagePayouts, kycReady, isLocaleSupported, payoutInfoChecked } = useCreditCardSetupContext();
  const { registryShippingAddress } = useShippingAddressAndCurrencyDialogsContext();

  if (!canManagePayouts) return false;
  // Avoid showing the button before we know whether an active payout account already exists —
  // otherwise it flashes visible on mount and disappears once the lookup resolves.
  if (payoutInfoChecked === false) return false;
  if (payoutAccountInfo && hasActiveStripeAccount(payoutAccountInfo.status)) return false;

  const hasUSShippingAddress = !!registryShippingAddress && registryShippingAddress.countryCode === 'USA';

  if (!isI18nEnabled) return hasUSShippingAddress;

  if (!kycReady) return false;
  return isLocaleSupported || hasUSShippingAddress;
};
